import React from 'react';
import { Filter } from 'lucide-react';

export const FilterControls = ({ filters, onFilterChange }) => {
  return (
    <div data-testid="filter-controls" className="bg-white border border-[hsl(var(--border))] rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <Filter className="w-4 h-4 text-[hsl(var(--text-secondary))]" />
        <span className="text-sm font-medium text-[hsl(var(--text-primary))]">Filters</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Asset Type */}
        <div>
          <label className="text-xs text-[hsl(var(--text-secondary))] mb-1 block">Asset Type</label>
          <select
            data-testid="filter-asset-type"
            value={filters.type || ''}
            onChange={(e) => onFilterChange('type', e.target.value)}
            className="w-full px-3 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--brand-primary))] text-sm"
          >
            <option value="">All Types</option>
            <option value="truck">Truck</option>
            <option value="trailer">Trailer</option>
          </select>
        </div>

        {/* Status */}
        <div>
          <label className="text-xs text-[hsl(var(--text-secondary))] mb-1 block">Status</label>
          <select
            data-testid="filter-status"
            value={filters.status || ''}
            onChange={(e) => onFilterChange('status', e.target.value)}
            className="w-full px-3 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--brand-primary))] text-sm"
          >
            <option value="">All Status</option>
            <option value="available">Available</option>
            <option value="sold_out">Sold Out</option>
            <option value="closed">Closed</option>
            <option value="coming_soon">Coming Soon</option>
          </select>
        </div>

        {/* Clear Filters */}
        <div className="flex items-end">
          <button
            data-testid="clear-filters-button"
            onClick={() => onFilterChange('clear')}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg text-sm font-medium text-[hsl(var(--text-secondary))] hover:bg-[hsl(var(--background-secondary))] transition-colors duration-200"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  );
};